import api from "./api"
import moment from "moment"
import { getStoredShipper } from "../constants/utils"

const GENERALPLACEMENTS_ROOT = "placements"

const generalPlacementsApi = {
    getAllRequests() {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.get(
            `${GENERALPLACEMENTS_ROOT}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/requests/summary/all`,
            "ROOT"
        )
    },
    getRequestDetails({ data, isfirstRequest }) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        if (isfirstRequest) {
            let firstRequest = data
                ? data.sort((a, b) => {
                      return (
                          new Date(b.serviceDateTime) -
                          new Date(a.serviceDateTime)
                      )
                  })[0]
                : {}
            return api.get(
                `${GENERALPLACEMENTS_ROOT}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/serviceDates/${
                    firstRequest.serviceDateTime
                }/requests/${encodeURIComponent(firstRequest.requestId)}`,
                "ROOT"
            )
        } else
            return api.get(
                `${GENERALPLACEMENTS_ROOT}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/serviceDates/${
                    data.serviceDateTime
                }/requests/${encodeURIComponent(data.requestId)}`,
                "ROOT"
            )
    },
    createNewRequest({
        serviceDate,
        serviceTime,
        requestID,
        equipmentDetails,
    }) {
        const {
            STORED_SHIPPER_NAME,
            STORED_RAILROAD_NAME,
            STORED_SHIPPER_NAME_ENCODED,
            STORED_RAILROAD_NAME_ENCODED,
        } = getStoredShipper()

        const SERVICE_DATE = moment(serviceDate).local().format("YYYY-MM-DD")
        const SERVICE_TIME = moment(serviceTime).local().format("HH:mm:ss")
        return api.post(
            `${GENERALPLACEMENTS_ROOT}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/requests`,
            {
                quantity: 1,
                status: "open",
                equipmentDetails: equipmentDetails,
                roadId: STORED_RAILROAD_NAME,
                shipperId: STORED_SHIPPER_NAME,
                serviceDateTime: `${SERVICE_DATE} ${SERVICE_TIME}`,
                requestId: requestID,
            },
            "ROOT"
        )
    },
    sendEmailNotification({
        serviceDateTime,
        requestId,
        equipmentDetails,
        emails,
    }) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        const SERVICE_DATE = moment(serviceDateTime).format("YYYY-MM-DD")
        const SERVICE_TIME = moment(serviceDateTime).format("HH:mm:ss")
        const DATE_TIME = `${SERVICE_DATE}T${SERVICE_TIME}`

        let params = {
            GeneralPlacement: {
                status: "open",
                equipmentDetails: equipmentDetails,
                RoadId: STORED_RAILROAD_NAME,
                ShipperId: STORED_SHIPPER_NAME,
                ServiceDateTime: DATE_TIME,
                RequestId: requestId,
            },
            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
        }

        if (emails.length) params["NotificationEmailAddresses"] = emails
        return api.post(
            `rvp/api/EmailGeneralPlacementInformation`,
            params,
            "ROOT"
        )
    },
}
export default generalPlacementsApi
